/* eslint-disable import/no-cycle */
/* eslint-disable import/prefer-default-export */
import _ from 'lodash';
import {
	setSelectedItem,
	setSelectedItemChangesClone,
	setNewItem,
	setIsSavingNewItem,
	setErrorMessageSaveNewItem,
	setIsSavingEditedItem,
	setErrorMessageSaveEditedItem,
	setIsDeletingItem,
	setErrorMessageDeleteItem,
	setConfirmationMessageKey,
  setShowConfirmation,
  setShowValidation
} from './actions';
import { selectIsFormValid } from '../selectors/validation';
import {
  insertJobLine,
	updateJobLine,
	deleteJobLine,
} from './api';
import { selectRootSliceFCCJ } from '../../../Main/selectors';
import {
	selectNewItem,
	selectErrorMessageSaveNewItem,
	selectHasChanges,
	selectSelectedItemChangesClone,
  selectSelectedItem,
  selectErrorMessageSaveEditedItem,
  selectErrorMessageDeleteItem,
} from '../selectors/selectors';
import { createNewJobLineObject, getDefaultAegionPm, getDefaultCustomer, getDefaultJobStatus, updateJobLineObject } from '../util';
import ConfirmUndoQueue from '../ConfirmUndoQueue';
import { MESSAGE_KEY_DELETE } from '../ConfirmUndoQueue.constants';
import { legacySelectCustomerFromPickerIgnoreSurveyCustomer as selectPickerName } from '../../../../legacy/selectors';
import { KEYS } from '../constants';
import { selectItems as selectCustomers } from '../../Customers/selectors';
import { selectItems as selectAegionPms } from '../../AegionProjectManagers/selectors';
import { selectItems as selectJobStatuses } from '../../Statuses/selectors';
import { generateScanlineLineDetailsLink } from '../../../../../../commons/components/AppToApp/util/GenerateAppLink';


/** ************
 * SET ITEM / NEW ITEM
 */

const thunkClearSelectedItem = () => (dispatch, getState) => {
  const item = selectSelectedItem(getState());
  const clone = selectSelectedItemChangesClone(getState());
  if (item) {
    dispatch(setSelectedItem(undefined));
  }
  if (clone) {
    dispatch(setSelectedItemChangesClone(undefined));
  }
}

const thunkClearNewItem = () => (dispatch, getState) => {
  const item = selectNewItem(getState());
  if (item) {
    dispatch(setNewItem(undefined));
  }
}

const thunkSetSelectedItem = item => (dispatch) => {
  if (item) {
    dispatch(thunkClearNewItem())
  }
	const clone = item ? _.cloneDeep(item) : item;
	dispatch(setSelectedItem(item));
	dispatch(setSelectedItemChangesClone(clone));
};

const thunkInitNewItem = () => (dispatch, getState) => {
  dispatch(thunkClearSelectedItem());

  const customerName = selectPickerName(getState());
  dispatch(setNewItem(createNewJobLineObject({
    [KEYS.CUSTOMER]: getDefaultCustomer(customerName, selectCustomers(getState())),
    [KEYS.AEGION_PROJECT_MANAGER]: getDefaultAegionPm(customerName, selectAegionPms(getState())),
    [KEYS.JOB_STATUS]: getDefaultJobStatus(customerName, selectJobStatuses(getState())),
  })));
};

const thunkUpdateNewItemProps = (props = {}) => (dispatch, getState) => {
  const newItem = selectNewItem(getState());
  const updatedNewItem = updateJobLineObject({ ...newItem }, props);
  dispatch(setNewItem(updatedNewItem));
}




/** ************
 * NEW ITEM
 */

const thunkClearErrorMessageSaveNewItem = () => (dispatch, getState) => {
	const stateAdmin = selectRootSliceFCCJ(getState());
	const message = selectErrorMessageSaveNewItem(stateAdmin);
	if (message) {
		dispatch(setErrorMessageSaveNewItem(undefined));
	}
};

const thunkSetErrorMessageSaveNewItem = error => dispatch => {
  if (typeof error === 'string') {
		dispatch(setErrorMessageSaveNewItem(error));
	} else if (error instanceof Object) {
		const { message } = error;
		if (message) {
			dispatch(setErrorMessageSaveNewItem(message));
		} else {
			dispatch(
				setErrorMessageSaveNewItem(
					'An unknown error occured, review the form and try again.'
				)
			);
		}
	} else {
		dispatch(
			setErrorMessageSaveNewItem(
				'An unknown error occured, review the form and try again'
			)
		);
	}
};

const thunkSaveNewItem = () => (dispatch, getState) => {
	const stateAdmin = selectRootSliceFCCJ(getState());
  const newItem = selectNewItem(stateAdmin);
  const isValid = selectIsFormValid(getState());

  if (newItem && isValid) {
    dispatch(thunkClearErrorMessageSaveNewItem());
    dispatch(setIsSavingNewItem(true));

    let newLine;
    insertJobLine({ jobLine: newItem })
      .then((res) => { 
        newLine = res?.line;
        // need to do some stuff here, probably return the link to open the analysis page.
        console.log(res);
      })
      .catch(err => { 
        dispatch(thunkSetErrorMessageSaveNewItem(err));
      }).finally(() => { 
        dispatch(setIsSavingNewItem(false));
        if (newLine) {
          setTimeout(() => { 
            window.location = generateScanlineLineDetailsLink(newLine.external_id, newLine.name);
          }, 1);
        }
      });
  } else { 
    dispatch(setShowValidation(true));
  }
};


/** ************
 * EDITED ITEM
 */

const thunkClearErrorMessageSaveEditedItem = () => (dispatch, getState) => {
	const stateAdmin = selectRootSliceFCCJ(getState());
	const message = selectErrorMessageSaveEditedItem(stateAdmin);
	if (message) {
		dispatch(setErrorMessageSaveEditedItem(undefined));
	}
};

const thunkSetErrorMessageSaveEditedItem = error => dispatch => {
	if (typeof error === 'string') {
		dispatch(setErrorMessageSaveEditedItem(error));
	} else if (error instanceof Object) {
		const { message } = error;
		if (message) {
			dispatch(setErrorMessageSaveEditedItem(message));
		} else {
			dispatch(setErrorMessageSaveEditedItem('An unknown error occured'));
		}
	} else {
		dispatch(setErrorMessageSaveEditedItem('An unknown error occured'));
	}
};

const thunkSaveEditedItem = () => (dispatch, getState) => {
	const stateAdmin = selectRootSliceFCCJ(getState());
	const editedItem = selectSelectedItemChangesClone(stateAdmin);
	const hasChanges = selectHasChanges(stateAdmin);

	if ((hasChanges) && editedItem) {
		dispatch(setErrorMessageSaveEditedItem(undefined));
		dispatch(setIsSavingEditedItem(true));

		updateJobLine({ jobLine: editedItem }, (err, updatedItem) => {
			if (err) {
				dispatch(thunkSetErrorMessageSaveEditedItem(err));
			} else {
				dispatch(thunkSetSelectedItem(updatedItem));
			}
			dispatch(setIsSavingEditedItem(false));
		});
	}
};



/** ************
 * DELETE ITEM
 */

const thunkClearErrorMessageDeleteItem = () => (dispatch, getState) => {
	const stateAdmin = selectRootSliceFCCJ(getState());
	const message = selectErrorMessageDeleteItem(stateAdmin);
	if (message) {
		dispatch(setErrorMessageDeleteItem(undefined));
	}
};

const thunkSetErrorMessageDeleteItem = error => dispatch => {
	if (typeof error === 'string') {
		dispatch(setErrorMessageDeleteItem(error));
	} else if (error instanceof Object) {
		const { message } = error;
		if (message) {
			dispatch(setErrorMessageDeleteItem(message));
		} else {
			dispatch(setErrorMessageDeleteItem('An unknown error occured'));
		}
	} else {
		dispatch(setErrorMessageDeleteItem('An unknown error occured'));
	}
};

const thunkDeleteItem = () => (dispatch, getState) => {
	const stateAdmin = selectRootSliceFCCJ(getState());
	const item = selectSelectedItem(stateAdmin);

	if (item) {
		dispatch(setErrorMessageDeleteItem(undefined));

		ConfirmUndoQueue.clear();
		dispatch(setConfirmationMessageKey(MESSAGE_KEY_DELETE));
		dispatch(setShowConfirmation(true));

		ConfirmUndoQueue.addToConfirmQueue(() => {
			dispatch(setIsDeletingItem(true));
			deleteJobLine({ jobLine: item }, err => {
				if (err) {
					dispatch(thunkSetErrorMessageDeleteItem(err));
				} else {
					dispatch(thunkSetSelectedItem(undefined));
				}
				dispatch(setConfirmationMessageKey());
				dispatch(setShowConfirmation(false));
				dispatch(setIsDeletingItem(false));
			});
		});
		ConfirmUndoQueue.addToUndoQueue(() => {
			dispatch(setConfirmationMessageKey(undefined));
			dispatch(setShowConfirmation(false));
		});
	}
};

const thunkConfirmDeleteItem = () => () => {
	ConfirmUndoQueue.executeConfirmQueue();
};
const thunkCancelDeleteItem = () => () => {
	ConfirmUndoQueue.executeUndoQueue();
};




/** ************
 * RESET
 */

const thunkClearAnyItem = () => (dispatch) => {
  dispatch(thunkClearSelectedItem());
  dispatch(thunkClearNewItem());
}

const thunkClearAllErrorMessages = () => (dispatch) => { 
  dispatch(thunkClearErrorMessageSaveNewItem());
  dispatch(thunkClearErrorMessageSaveEditedItem());
  dispatch(thunkClearErrorMessageDeleteItem());
}


export {
  thunkSetSelectedItem,
  thunkClearSelectedItem,

  thunkInitNewItem,
  thunkClearNewItem,
  thunkUpdateNewItemProps,

  thunkSaveNewItem,  
	thunkSetErrorMessageSaveNewItem,
	thunkClearErrorMessageSaveNewItem,

  thunkSaveEditedItem,
	thunkSetErrorMessageSaveEditedItem,
	thunkClearErrorMessageSaveEditedItem,

  thunkDeleteItem,
	thunkSetErrorMessageDeleteItem,
	thunkClearErrorMessageDeleteItem,
	thunkConfirmDeleteItem,
  thunkCancelDeleteItem,

  thunkClearAnyItem,
  thunkClearAllErrorMessages,
  
};
